import UserOpinions from './UserOpinions';

export default UserOpinions;
